import React from "react";
import { Dialog, DialogPanel } from "@headlessui/react";

import styles from "./FinishDialog.module.scss";
import { ReactComponent as Warning } from "assets/misc/warning_circle.svg";
import { ReactComponent as Tick } from "assets/misc/tick_circle.svg";

interface FinishgDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title: string;
  message: string;
  confirmButtonLabel?: string;
  onConfirm?: () => void;
  warning?: boolean;
}

const FinishDialog = ({
  isOpen,
  setIsOpen,
  title,
  message,
  confirmButtonLabel = "Proceed",
  onConfirm,
  warning = false,
}: FinishgDialogProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className={styles.dialog}
    >
      <div className={styles.backdrop}>
        <DialogPanel className={styles.panel}>
          <div className={styles.content}>
            {warning ? (
              <Warning className={styles.headerIcon} />
            ) : (
              <Tick className={styles.headerIcon} />
            )}
            <span className={styles.title}>{title}</span>
            <span>{message}</span>
          </div>
          {warning && (
            <div className={styles.controls}>
              <button
                className={`${styles.button} ${styles.cancelButton}`}
                onClick={() => setIsOpen(false)}
              >
                Cancel
              </button>
              <button
                className={`${styles.button} ${styles.warningConfirmButton}`}
                onClick={() => {
                  onConfirm?.();
                  setIsOpen(false);
                }}
              >
                {confirmButtonLabel}
              </button>
            </div>
          )}
          {!warning && (
            <div className={styles.controls}>
              <button
                className={`${styles.button} ${styles.okConfirmButton}`}
                onClick={() => {
                  onConfirm?.();
                  setIsOpen(false);
                }}
              >
                {confirmButtonLabel}
              </button>
            </div>
          )}
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default FinishDialog;
